// extracted by mini-css-extract-plugin
module.exports = {"eChallanStates":"_3apos","sellOrBuyCarWrapper":"_3QWod"};